<script>
import { overlay } from "../Store/OverlayStore"

export let location

// vars
const href = location.context_urls[$overlay.context.id] || null
</script>

<a class="card" {href} data-location={location.slug}>
	<div class="card__content">
		<span class="card__location">{location.city.title}</span>
		<span class="card__city">{location.title}</span>
	</div>
</a>
